import { useQuery } from 'react-query';

import {
  enterpriseSavedMessagesRoute,
  enterpriseSavedMessagesKey,
  SavedMessage,
  savedNotesKey,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseSavedMessagesProps = {
  enabled: boolean;
  isNote?: boolean;
  company_id?: string | number;
};

export const useGetEnterpriseSavedMessages = ({ enabled, isNote, company_id }: useGetEnterpriseSavedMessagesProps) => {
  const { data: savedEnterpriseMessages, isLoading: isLoadingSavedEnterpriseMessages } = useQuery<{ object?: SavedMessage[] }>(
    [isNote ? enterpriseSavedMessagesKey : savedNotesKey, company_id],
    {
      enabled: enabled && company_id !== null,
      queryFn: () =>
        axiosInstance.get(enterpriseSavedMessagesRoute + `?company_id=${company_id}` + (isNote ? '&is_note=true' : '')).then((res) => res.data),
      refetchOnWindowFocus: false,
    },
  );

  return {
    savedEnterpriseMessages,
    isLoadingSavedEnterpriseMessages
  };
};
